import { useState ,useEffect} from "react"
import { getSubrubroById, postSubrubro, patchSubrubro} from "../../services/SubrubrosServices"
import { SubrubrosFormContext } from "./SubrubrosContext"
import { useNavigate, useParams } from 'react-router-dom';

export const SubrubrosFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

  useEffect(() => {
    if (id) getSubrubroByIdData(id)
}, [])

    const getSubrubroByIdData = async (id) => {
        let res = await getSubrubroById(id)
        if (res) setReport(res)
    }
    
    const postSubrubroData = async (body) => {
        const res = await postSubrubro(body)
        if (res) navigate("/Subrubros");
    }

    const patchSubrubroData = async (id, body) => {
        const res = await patchSubrubro(id, body)
        if (res) navigate("/Subrubros");
    }

    return <SubrubrosFormContext.Provider value={{
        report,
        postSubrubroData,
        patchSubrubroData,
        getSubrubroByIdData,
    }} >
        {children}
    </SubrubrosFormContext.Provider>
}